@use "@fukuri-admins/ui/layout" as *;

.modalContent {
  display: flex;
  flex-direction: column;
  gap: spacing("24");
  padding: spacing("16") 0;
}

.modalRow {
  display: flex;
  align-items: center;
  gap: spacing("24");
}

.modalLabel {
  @include typography("Jp/14_W3");
  color: text('Low');
  min-width: 128px;
}

.modalValue {
  @include typography("Jp/14_W3");
  color: text('High');
}
